/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feature_Animation_Exclusive_Tree_TitleInputs */

const en_feature_animation_exclusive_tree_title = /** @type {(inputs: Feature_Animation_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy the <span style="@@">exclusive trees</span>, only on Plus`)
};

const ar_feature_animation_exclusive_tree_title = /** @type {(inputs: Feature_Animation_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استمتع ب <span style="@@">أشجار حصرية</span>، متوفرة فقط على بلس`)
};

const de_feature_animation_exclusive_tree_title = /** @type {(inputs: Feature_Animation_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genießen Sie die <span style="@@">exklusive Bäume</span>, nur auf Plus`)
};

const es_feature_animation_exclusive_tree_title = /** @type {(inputs: Feature_Animation_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disfruta de los <span style="@@">árboles exclusivos</span>, sólo en Plus`)
};

const fr_feature_animation_exclusive_tree_title = /** @type {(inputs: Feature_Animation_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profitez d'<span style="@@">arbres exclusifs</span>, seulement avec Forest Plus`)
};

const it_feature_animation_exclusive_tree_title = /** @type {(inputs: Feature_Animation_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goditi <span style="@@">alberi esclusivi</span>, solo su Plus`)
};

const ja_feature_animation_exclusive_tree_title = /** @type {(inputs: Feature_Animation_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus<span style="@@">限定の木</span>を楽しもう`)
};

const ko_feature_animation_exclusive_tree_title = /** @type {(inputs: Feature_Animation_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus에서만 제공되는 <span style="@@">특별한 나무</span>를 심어 보세요`)
};

const pt_br_feature_animation_exclusive_tree_title = /** @type {(inputs: Feature_Animation_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproveite as <span style="@@">árvores exclusivas</span>, somente com o Plus`)
};

const ru_feature_animation_exclusive_tree_title = /** @type {(inputs: Feature_Animation_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получайте <span style="@@">эксклюзивные деревья</span> только в Plus`)
};

const th_feature_animation_exclusive_tree_title = /** @type {(inputs: Feature_Animation_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพลิดเพลินกับ<span style="@@">ต้นไม้สุดพิเศษ</span>เฉพาะบน Plus`)
};

const tr_feature_animation_exclusive_tree_title = /** @type {(inputs: Feature_Animation_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="@@">Özel ağaçların</span> keyfini çıkar, yalnızca Plus'ta`)
};

const zh_cn_feature_animation_exclusive_tree_title = /** @type {(inputs: Feature_Animation_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 专享<span style="@@">开运元树</span>，
为你专注加持好运！`)
};

const zh_tw_feature_animation_exclusive_tree_title = /** @type {(inputs: Feature_Animation_Exclusive_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 專享<span style="@@">開運元樹</span>，
為你專注加持好運！`)
};

/**
* | output |
* | --- |
* | "Enjoy the <span style=\"@@\">exclusive trees</span>, only on Plus" |
*
* @param {Feature_Animation_Exclusive_Tree_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const feature_animation_exclusive_tree_title = /** @type {((inputs?: Feature_Animation_Exclusive_Tree_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feature_Animation_Exclusive_Tree_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_feature_animation_exclusive_tree_title(inputs)
	if (locale === "ar") return ar_feature_animation_exclusive_tree_title(inputs)
	if (locale === "de") return de_feature_animation_exclusive_tree_title(inputs)
	if (locale === "es") return es_feature_animation_exclusive_tree_title(inputs)
	if (locale === "fr") return fr_feature_animation_exclusive_tree_title(inputs)
	if (locale === "it") return it_feature_animation_exclusive_tree_title(inputs)
	if (locale === "ja") return ja_feature_animation_exclusive_tree_title(inputs)
	if (locale === "ko") return ko_feature_animation_exclusive_tree_title(inputs)
	if (locale === "pt_br") return pt_br_feature_animation_exclusive_tree_title(inputs)
	if (locale === "ru") return ru_feature_animation_exclusive_tree_title(inputs)
	if (locale === "th") return th_feature_animation_exclusive_tree_title(inputs)
	if (locale === "tr") return tr_feature_animation_exclusive_tree_title(inputs)
	if (locale === "zh_cn") return zh_cn_feature_animation_exclusive_tree_title(inputs)
	return zh_tw_feature_animation_exclusive_tree_title(inputs)
});